import { render, staticRenderFns } from "./ActiveApiCalls.vue?vue&type=template&id=f5defd04&scoped=true&"
import script from "./ActiveApiCalls.vue?vue&type=script&lang=js&"
export * from "./ActiveApiCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5defd04",
  null
  
)

export default component.exports